<script setup>
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisField from 'dashboard/components-next/LaisField.vue';

const props = defineProps({
  errors: { type: Object, default: () => ({}) },
  index: { type: Number, required: true },
  service: { type: Object, required: true },
  serviceEntry: { type: Function, required: true },
  serviceTypes: { type: Array, default: () => [] },
});

const emit = defineEmits(['updateService']);
const { t } = useI18n();
const servicesFor = service =>
  props.serviceTypes.find(type => String(type.id) === String(service.tipo))
    ?.services || [];
const update = (field, value) =>
  emit('updateService', props.index, field, value);
</script>

<template>
  <LaisCard
    :title="
      t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.ITEM', {
        number: index + 1,
      })
    "
    prefix-icon="i-lucide-file-check-2"
  >
    <div class="grid gap-4 sm:grid-cols-2">
      <LaisField
        :label="t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.TYPE')"
        required
      >
        <select
          :value="service.tipo"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          @change="update('tipo', $event.target.value)"
        >
          <option value="">
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT_TYPE') }}
          </option>
          <option v-for="type in serviceTypes" :key="type.id" :value="type.id">
            {{ type.name }}
          </option>
        </select>
      </LaisField>
      <LaisField
        :label="t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.DETAIL')"
        :error="errors[`service_${index}`]"
        required
      >
        <select
          :value="service.servicoDetalhado"
          class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
          :disabled="!service.tipo"
          @change="update('servicoDetalhado', $event.target.value)"
        >
          <option value="">
            {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT_SERVICE') }}
          </option>
          <option
            v-for="item in servicesFor(service)"
            :key="item.id"
            :value="item.id"
          >
            {{ item.name }}
          </option>
        </select>
      </LaisField>
    </div>

    <LaisField
      v-if="serviceEntry(service)?.context?.type === 'text'"
      :label="serviceEntry(service).context.label"
      :error="errors[`context_${index}`]"
      :required="serviceEntry(service).context.required"
    >
      <input
        :value="service.valorServicoDetalhado"
        :placeholder="serviceEntry(service).context.placeholder"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        @input="update('valorServicoDetalhado', $event.target.value)"
      />
    </LaisField>
    <LaisField
      v-if="serviceEntry(service)?.context?.type === 'select'"
      :label="serviceEntry(service).context.label"
      :error="errors[`context_${index}`]"
      :required="serviceEntry(service).context.required"
    >
      <select
        :value="service.valorServicoDetalhado"
        class="min-h-10 rounded-lais border border-lais-border bg-white px-3 text-sm"
        @change="update('valorServicoDetalhado', $event.target.value)"
      >
        <option value="">
          {{ t('NUCLEO_WORK_ORDERS.REQUEST.FIELDS.SELECT') }}
        </option>
        <option
          v-for="option in serviceEntry(service).context.options"
          :key="option.id"
          :value="option.id"
        >
          {{ option.name }}
        </option>
      </select>
    </LaisField>
    <LaisField :label="t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.OBSERVATION')">
      <textarea
        :value="service.observacao"
        rows="4"
        class="rounded-lais border border-lais-border bg-white px-3 py-2 text-sm"
        :placeholder="
          t('NUCLEO_WORK_ORDERS.REQUEST.SERVICES.OBSERVATION_PLACEHOLDER')
        "
        @input="update('observacao', $event.target.value)"
      />
    </LaisField>
  </LaisCard>
</template>
